var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.745,
    height: 11.721,
    viewBox: "0 0 10.745 11.721",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-959 -229)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(959 229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.273,12.082A2.078,2.078,0,0,1,3.2,10.006V5H2.343A1.344,1.344,0,0,0,1,6.343v6.593a1.344,1.344,0,0,0,1.343,1.343h6.1a1.344,1.344,0,0,0,1.343-1.343v-.855Z",
    transform: "translate(-1 -2.558)",
    fill: "#1f2f3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.814,1.343A1.343,1.343,0,0,0,13.471,0H8.343A1.343,1.343,0,0,0,7,1.343v6.1A1.343,1.343,0,0,0,8.343,8.791h5.128a1.343,1.343,0,0,0,1.343-1.343Z",
    transform: "translate(-4.07)",
    fill: "#1f2f3d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloneIcon);
export default __webpack_public_path__ + "static/media/clone-icon.1fc2eda455761ae0e65ef9e984ef48d5.svg";
export { ForwardRef as ReactComponent };